/** Setup catalogs API — price books, rate cards, reminders (kosh-commercial / kosh-receivables). */
import { apiClient } from './api-client';
import type { Paginated } from '@/types/kosh';
import type {
  KoshCatalogStatus,
  KoshPriceBook,
  KoshRateCard,
  KoshReminder,
  KoshReminderStatus,
} from '@/types/catalogs';

type Query = Record<string, string | number | boolean | undefined>;
function rows<T>(d: Paginated<T> | T[] | null | undefined): T[] {
  if (!d) return [];
  return Array.isArray(d) ? d : d.items;
}

export const priceBooksApi = {
  list: async (params?: Query) => {
    const { data } = await apiClient.get<Paginated<KoshPriceBook> | KoshPriceBook[]>(
      '/kosh/price-books',
      { params },
    );
    return rows<KoshPriceBook>(data);
  },
  get: (id: string) =>
    apiClient.get<KoshPriceBook>(`/kosh/price-books/${id}`).then((r) => r.data),
  transition: (id: string, to: KoshCatalogStatus) =>
    apiClient
      .post<KoshPriceBook>(`/kosh/price-books/${id}/transitions`, { to })
      .then((r) => r.data),
};

export const rateCardsApi = {
  list: async (params?: Query) => {
    const { data } = await apiClient.get<Paginated<KoshRateCard> | KoshRateCard[]>(
      '/kosh/rate-cards',
      { params },
    );
    return rows<KoshRateCard>(data);
  },
  get: (id: string) =>
    apiClient.get<KoshRateCard>(`/kosh/rate-cards/${id}`).then((r) => r.data),
  transition: (id: string, to: KoshCatalogStatus) =>
    apiClient
      .post<KoshRateCard>(`/kosh/rate-cards/${id}/transitions`, { to })
      .then((r) => r.data),
};

export const remindersApi = {
  list: async (params?: Query) => {
    const { data } = await apiClient.get<Paginated<KoshReminder> | KoshReminder[]>(
      '/kosh/reminders',
      { params },
    );
    return rows<KoshReminder>(data);
  },
  transition: (id: string, to: KoshReminderStatus) =>
    apiClient
      .post<KoshReminder>(`/kosh/reminders/${id}/transitions`, { to })
      .then((r) => r.data),
};
